'use client'

import { JourneysProvider } from '@/context/journeys';
import { useTranslations } from 'next-intl';
import dynamic from 'next/dynamic';
const MainSection = dynamic(() => import('@/components/pages/home-page/main-section'), { ssr: false });
const PageContainer = dynamic(() => import('@/components/common/page-container'), { ssr: false });
const BoxWithTitle = dynamic(() => import('@/components/common/box-with-title'), { ssr: false });
const ApplicationStatus = dynamic(() => import('@/components/pages/home-page/start-jouney-card'), { ssr: false });
// const ProfileCard = dynamic(() => import('@/components/widgets/profile-card'), { ssr: false });
const DanaCard = dynamic(() => import('@/components/widgets/dana-card'), { ssr: false });
// const JourneyStepsContainer = dynamic(() => import('@/components/pages/home-page/journey-steps-container'), { ssr: false });
const JourneyListContainer = dynamic(() => import('@/components/pages/home-page/journeys-list-container'), { ssr: false });

export default function Home() {
  const t = useTranslations('homepage');
  const dana = useTranslations('homepage.dana_card');

  return <PageContainer
    className='__PageContainer__ flex flex-wrap lg:gap-8 gap-[24px] lg:pt-[31px]'
  >
    <h1 className='__PageContainer__h1__ lg:mb-6 mb-2'>{t('title')}</h1>

    <MainSection>
      <ApplicationStatus />
    </MainSection>

    <MainSection>
      <JourneysProvider>
        <JourneyListContainer />
      </JourneysProvider>
      <BoxWithTitle title={dana('title')}>
        <DanaCard />
      </BoxWithTitle>

    </MainSection>
  </PageContainer>
};
